module.exports = __webpack_public_path__ + "img/chinesecompany192.30766a8e.png";